import clsx from 'clsx';

export function CheckboxIndeterminateIcon({ className }) {
  return (
    <svg
      className={clsx(className)}
      width="10"
      height="2"
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M0 1H10" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
